import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Button, Grid, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import SweetAlert from "react-bootstrap-sweetalert"
import { dateFormatter } from "../../Utils/Formatter"
import { visitTypeEnum } from "../../../variables/Enums"
import { IconSVG, OnSite, Phone, VideoCall } from "../../Icons/Icons"
import { ModalData } from "../../Modals/ModalData"
import { ModalConfirm } from "../../Modals/ModalConfirm";

export const ConfirmVisitTracking = (props) => {
    const {
        onConfirm,
        onClose
    } = props;
    const { t } = useTranslation();

    return (
        <SweetAlert
            warning
            title={t("protocolNotifications.visitTracking_confirmSave_title")}
            onConfirm={onConfirm}
            onCancel={onClose}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="info"
            confirmBtnText={t("buttons.yes")}
            cancelBtnText={t("buttons.no")}
            showCancel
        >
            <>
                <span>{t("protocolNotifications.visitTracking_confirmSave_description")}</span>

                <div>Rango: {dateFormatter(props.data.fromDate, "DD/MMMM/YYYY")} - {dateFormatter(props.data.toDate, "DD/MMMM/YYYY")}</div>
            </>
        </SweetAlert>
    );
}

ConfirmVisitTracking.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export const ChangeVisitType = ({ visit, onChange, onClose }) => {
    const { t } = useTranslation();
    const [modal, setModal] = useState(null);

    const handleChangeType = (type) => {
        setModal(
            <ModalConfirm
                onConfirm={() => onChange(type)}
                onCancel={() => { setModal(null); onClose() }}
                title={t("protocolNotifications.visitTracking_changeType_title")}
                description={t("protocolNotifications.visitTracking_changeType_description")}
            />);
    }

    if (modal)
        return modal;

    return (<ModalData
        size=""
        className=""
        title={t("protocolNotifications.visitTracking_changeType_title")}
        isShowing={true}
        hide={onClose}>
        <div className="modal-create-entry">
            <Grid fluid>
                <Row className='display-flex'>
                    <Col md={4}>
                        <div className="create-entry-container">
                            <Button onClick={() => handleChangeType(visitTypeEnum.OnSite)} className="btn-create-entry">
                                <OnSite />
                            </Button>
                            <div className="title-create-entry">{t("protocols.visitTracking.onsite")}</div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="create-entry-container">
                            <Button onClick={() => handleChangeType(visitTypeEnum.Telephone)} className="btn-create-entry">
                                <Phone />
                            </Button>
                            <div className="title-create-entry">{t("protocols.visitTracking.telephone")}</div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="create-entry-container">
                            <Button onClick={() => handleChangeType(visitTypeEnum.Remote)} className="btn-create-entry">
                                <VideoCall />
                            </Button>
                            <div className="title-create-entry">{t("protocols.visitTracking.remote")}</div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        </div>
    </ModalData>);
}